module.exports = __webpack_public_path__ + "logoyungol.svg?5ff58c837885d9b4419d6da3bba35ec2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoyungol.svg
// module id = 96
// module chunks = 0